import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-plumdeep text-[#C9B8BE]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex flex-col leading-none mb-6">
            <span className="font-serif text-2xl tracking-wide text-ivory">Exclusive</span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-dustyrose font-sans font-semibold">
              Society
            </span>
          </div>
          <p className="text-sm font-light leading-relaxed max-w-xs">
            Agencia de desarrollo, representación y gestión de modelos y creadoras de contenido en el mundo digital.
          </p>
          <span
            data-testid="footer-age-badge"
            className="inline-block mt-6 border border-dustyrose/50 text-dustyrose text-[11px] uppercase tracking-[0.2em] px-4 py-2"
          >
            Exclusivo +18
          </span>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-dustyrose mb-6 font-sans font-semibold">Explora</h4>
          <ul className="space-y-3 text-sm font-light">
            <li><Link data-testid="footer-link-inicio" to="/" className="hover:text-ivory transition-colors">Inicio</Link></li>
            <li><Link data-testid="footer-link-nosotros" to="/nosotros" className="hover:text-ivory transition-colors">Nosotros</Link></li>
            <li><Link data-testid="footer-link-servicios" to="/servicios" className="hover:text-ivory transition-colors">Servicios</Link></li>
            <li><Link data-testid="footer-link-como-funciona" to="/como-funciona" className="hover:text-ivory transition-colors">Cómo funciona</Link></li>
            <li><Link data-testid="footer-link-preguntas" to="/preguntas" className="hover:text-ivory transition-colors">Preguntas</Link></li>
            <li><Link data-testid="footer-link-postula" to="/postula" className="hover:text-ivory transition-colors">Postula</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-dustyrose mb-6 font-sans font-semibold">Legal</h4>
          <ul className="space-y-3 text-sm font-light">
            <li><Link data-testid="footer-link-contacto" to="/contacto" className="hover:text-ivory transition-colors">Contacto</Link></li>
            <li><Link data-testid="footer-link-privacidad" to="/privacidad" className="hover:text-ivory transition-colors">Privacidad</Link></li>
            <li><Link data-testid="footer-link-terminos" to="/terminos" className="hover:text-ivory transition-colors">Términos del sitio</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/10 mt-14 pt-8 flex flex-col md:flex-row justify-between gap-4">
        <p className="text-xs font-light">© {new Date().getFullYear()} Exclusive Society. Todos los derechos reservados.</p>
        <p className="text-xs font-light max-w-md">
          No se garantizan ingresos. Los resultados dependen de cada proyecto, la audiencia y las condiciones de las
          plataformas.
        </p>
      </div>
    </div>
  </footer>
);
